import { postGDCDetaliedPlanHistory } from '@auteco/services/gdcServices'
import { Button, Dialog, DialogContent, DialogTitle, TextField, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'

const useStyles = makeStyles(() => ({
    dialogContent: {
        minWidth: '400px'
    },
    dialogBody: {
        display: 'flex', flexDirection: 'column'
    },
    dialogBtn: {
        width: '80px',
        margin: '12px auto'
    },
}))

const DialogAddNote = ({ open, onClose, item }) => {
    const [historyTxt, setHistoryTxt] = useState('')
    const classes = useStyles()

    const handleClose = () => {
        onClose()
        setHistoryTxt('')
    }

    const postNote = async () => {
        const body = {
            plan_id: item.id,
            texto: historyTxt
        }
        await postGDCDetaliedPlanHistory({ params: body })
        handleClose()
    }
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogContent className={classes.dialogContent}>
                <DialogTitle>Añade tu nota</DialogTitle>
                <div className={classes.dialogBody}>
                    <TextField
                        variant='outlined'
                        multiline
                        minRows={3}
                        onChange={(e) => setHistoryTxt(e.target.value)}
                    />
                    <Button
                        variant='contained'
                        color='primary'
                        className={classes.dialogBtn}
                        disabled={historyTxt === ''}
                        onClick={postNote}
                    >
                        Enviar
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export { DialogAddNote }